import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props { children: ReactNode }
interface State { error: Error | null }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error("[P2HM ErrorBoundary]", error, info);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen grid place-items-center p-6 bg-background text-foreground">
          <div className="max-w-md w-full glass-panel rounded-xl border border-destructive/40 p-6 space-y-4">
            <div className="flex items-center gap-2 text-destructive">
              <AlertTriangle className="w-5 h-5" />
              <h2 className="font-display font-semibold">Algo quebrou</h2>
            </div>
            <p className="text-sm text-muted-foreground">
              Um erro inesperado aconteceu. Você pode tentar novamente — seus dados estão salvos.
            </p>
            <pre className="text-[10px] font-mono bg-surface-2 p-2 rounded max-h-40 overflow-auto">
              {this.state.error.message}
            </pre>
            <div className="flex gap-2">
              <Button onClick={this.reset} className="gap-1.5"><RefreshCw className="w-3.5 h-3.5" /> Tentar de novo</Button>
              <Button variant="outline" onClick={() => (window.location.href = "/")}>Voltar ao início</Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
